// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__pWgnm","content":"ManualTimeModal_content__2yi_H"};